import React from 'react';
import { KeyedClusivitySeparatedPrices } from '../../util/taxDisplayPricingHelpers';
import { OrderDetails } from '../../types/orderDetails';
// This context remembers information about the order, and keeps track
// of what lens this app is viewing the order through:
// eg. orderDetails or orderConfirmation

type OrderDetailsContextProps = {
  orderNumber?: string;
  vistacartTenantName?: string;
  shopperId?: string;
  tenantEnvironment?: string;
  currency?: string;
  fractionDigits?: number;
  order?: OrderDetails;
  itemIdToTaxInclusiveAndExclusivePricesMap?: KeyedClusivitySeparatedPrices;
  itemGroupIdToTaxInclusiveAndExclusivePricesMap?: KeyedClusivitySeparatedPrices;
  itemIdToTaxInclusiveAndExclusiveShippingPricesMap?: KeyedClusivitySeparatedPrices;
  showShipmentDetails?: boolean;
  isSmsSubscriptionModalOpen?: boolean;
  setIsSmsSubscriptionModalOpen?: (arg: boolean) => void;
};

export const OrderDetailsContext =
  React.createContext<OrderDetailsContextProps>({});

export const OrderDetailsProvider = OrderDetailsContext.Provider;
export const OrderDetailsConsumer = OrderDetailsContext.Consumer;

export default OrderDetailsContext;
